import {
  Box,
  Container,
  Flex,
  Stack,
  Text,
  HStack,
  Link,
  IconButton,
  useColorModeValue,
} from "@chakra-ui/react";
import { ArrowUpIcon } from "@chakra-ui/icons";
import { FaLinkedin, FaGithub } from "react-icons/fa";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import t from "../translations";

const MotionBox = motion(Box);

export default function Footer({ color }) {
  const textColor = useColorModeValue("gray.500", "gray.400");
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.1 });

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <MotionBox
      ref={ref}
      initial={{ opacity: 0, y: 20 }}
      animate={inView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.5, ease: "easeOut" }}
      bg={useColorModeValue("gray.50", "gray.900")}
    >
      {/* Gradient separator line */}
      <Box
        h="1px"
        bgGradient="linear(to-r, transparent, purple.400, transparent)"
      />

      <Container as={Stack} maxW="6xl" py={6}>
        <Stack
          direction={{ base: "column", md: "row" }}
          align="center"
          spacing={4}
        >
          <Flex flex="1" justify={{ base: "center", md: "flex-start" }}>
            <Text fontSize="sm" color={textColor}>
              &copy; {new Date().getFullYear()} {t.footer.copyright}
            </Text>
          </Flex>
          <Flex flex="1" justify="center" align="center" gap={3}>
            <Text fontSize="xs" color={textColor}>
              {t.footer.builtWith}
            </Text>
            <IconButton
              icon={<ArrowUpIcon />}
              aria-label="Back to top"
              size="xs"
              variant="ghost"
              colorScheme={color}
              onClick={scrollToTop}
              _hover={{ transform: "translateY(-2px)" }}
              transition="all 0.2s"
            />
          </Flex>
          <Flex flex="1" justify={{ base: "center", md: "flex-end" }}>
            <HStack spacing={4}>
              <Link
                href={t.profile.linkedin}
                isExternal
                aria-label="LinkedIn"
                color={textColor}
                _hover={{
                  color: `${color}.400`,
                  transform: "scale(1.15) translateY(-2px)",
                }}
                transition="all 0.2s"
                display="inline-flex"
              >
                <FaLinkedin size={18} />
              </Link>
              <Link
                href={t.profile.github}
                isExternal
                aria-label="GitHub"
                color={textColor}
                _hover={{
                  color: `${color}.400`,
                  transform: "scale(1.15) translateY(-2px)",
                }}
                transition="all 0.2s"
                display="inline-flex"
              >
                <FaGithub size={18} />
              </Link>
            </HStack>
          </Flex>
        </Stack>
      </Container>
    </MotionBox>
  );
}
